module.exports = __webpack_public_path__ + "img/bg3.a71787d2.png";